/* Skapad av Claude Code – Expand/collapse-logik för svd-pdp-problems-2026 (v2) */
(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.svdPrInit === 'true') return;
    root.dataset.svdPrInit = 'true';

    var singleOpen = root.dataset.singleOpen === 'true';
    var pairOpen = root.dataset.pairOpen === 'true';
    var toggles = root.querySelectorAll('[data-svd-pr-toggle]');

    function setItemState(item, open) {
      if (!item) return;
      item.dataset.open = open ? 'true' : 'false';
      var btn = item.querySelector('[data-svd-pr-toggle]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panelId = btn ? btn.getAttribute('aria-controls') : null;
      if (panelId) {
        var panel = root.querySelector('#' + CSS.escape(panelId));
        if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
    }

    function getPair(item) {
      if (!pairOpen) return [item];
      var items = Array.from(root.querySelectorAll('.svd-pr__item'));
      var idx = items.indexOf(item);
      if (idx === -1) return [item];
      var pairIdx = idx % 2 === 0 ? idx + 1 : idx - 1;
      var pair = [item];
      if (items[pairIdx]) pair.push(items[pairIdx]);
      return pair;
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.svd-pr__item');
        if (!item) return;

        var isOpen = item.dataset.open === 'true';
        var pair = getPair(item);

        if (singleOpen && !isOpen) {
          root.querySelectorAll('.svd-pr__item[data-open="true"]').forEach(function (other) {
            if (pair.indexOf(other) === -1) {
              setItemState(other, false);
            }
          });
        }

        pair.forEach(function (p) {
          setItemState(p, !isOpen);
        });
      });
    });
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll('[data-svd-pr-root]');
    roots.forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify Theme Editor – re-init när sektionen laddas om
  if (typeof document !== 'undefined') {
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  }
})();
